module.exports = function() {
  return new Worker(__webpack_public_path__ + "bcf8bb26eba819226cc9.worker.js");
};